import { useEffect, useState } from 'react';

export const DropdownV2 = ({
    options,
    label = 'Select Option',
    defaultValue = null,
    disabled = false,
    handleChange,
    ...props
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(defaultValue || label);

    useEffect(()=>{
        if (defaultValue || label) {
            setSelected(defaultValue || label);
        }
    },[label, defaultValue]);

    const handleSelect = (option) => {
        let validationResult = true;
        if (props?.validation) {
            validationResult = props?.handleValidate()
        }
        if (!validationResult) return;
        setSelected(option.name);
        handleChange(option?.id);
        setIsOpen(false);
    };

    return (
        <div className="relative inline-block text-left">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="button bg-primary-light hover:text-white shadow-md relative hover:bg-primary hover:text-primary border border-primary hover:border-primary-light"
                type="button"
                disabled={disabled}
            >
                <span>{selected}</span>
                <svg className="w-2.5 h-2.5 ms-3 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l4 4 4-4" />
                </svg>
            </button>

            {isOpen && (
                <div className="absolute mt-2 z-10 bg-slate-200 divide-y divide-gray-100 rounded-lg shadow-sm w-44 dark:bg-gray-700">
                    <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
                        {options.map((option, index) => (
                            <li key={index}>
                                <button
                                    onClick={() => handleSelect(option)}
                                    className="w-full text-left block px-4 py-2 hover:bg-white dark:hover:bg-gray-600 dark:hover:text-white"
                                >
                                    {option.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};
